import Connect from 'pages/connect/views/main';
import SalesforceLoginHandler from './views/salesforce';
import HubspotLoginHandler from './views/hubspot';
import PipedriveLoginHandler from './views/pipedrive';
import AttioLoginHandler from './views/attio';
import ZohoLoginHandler from './views/zoho';
import ZohoLoginStart from './views/zoho/ZohoLoginStart';
import DynamicsLoginHandler from './views/dynamics';
import DynamicsLoginStart from './views/dynamics/DynamicsLoginStart';
import { RouteObject } from 'react-router-dom';
import OutlookLoginHandler from './views/outlook';
import AircallLoginHandler from './views/aircall';
import ZoomInfoLoginHandler from './views/zoominfo';

const Routes: RouteObject[] = [
  {
    index: true,
    element: <Connect />,
  },
  {
    path: 'salesforce/callback',
    element: <SalesforceLoginHandler />,
  },
  {
    path: 'hubspot/callback',
    element: <HubspotLoginHandler />,
  },
  {
    path: 'pipedrive/callback',
    element: <PipedriveLoginHandler />,
  },
  {
    path: 'attio/callback',
    element: <AttioLoginHandler />,
  },
  {
    path: 'zoho/start',
    element: <ZohoLoginStart />,
  },
  {
    path: 'zoho/callback',
    element: <ZohoLoginHandler />,
  },
  {
    path: 'dynamics/start',
    element: <DynamicsLoginStart />,
  },
  {
    path: 'dynamics/callback',
    element: <DynamicsLoginHandler />,
  },
  {
    path: 'outlook/callback',
    element: <OutlookLoginHandler />,
  },
  {
    path: 'aircall/callback',
    element: <AircallLoginHandler />,
  },
  {
    path: 'zoominfo/callback',
    element: <ZoomInfoLoginHandler />,
  },
];

export default Routes;
